import { useEffect } from 'react';

// SEO configuration for each page
const seoConfig = {
    home: {
        title: "White Valley Cafe & Multicuisine Restaurant | Best Poolside Dining in Rajkot",
        description: "Experience the best poolside multi-cuisine vegetarian restaurant in Rajkot. Enjoy Italian, Continental & North Indian dishes at White Valley Cafe. Open daily 10 AM - 1 AM."
    },
    menu: {
        title: "Menu | White Valley Cafe - Vegetarian Multicuisine Restaurant in Rajkot",
        description: "Explore our vegetarian menu featuring Italian, Continental, North Indian, South Indian dishes, sizzlers, pizza, pasta, and more. ₹400-600 per person at White Valley Cafe Rajkot."
    },
    gallery: {
        title: "Photo Gallery | White Valley Cafe - Poolside Restaurant Rajkot",
        description: "View stunning photos of White Valley Cafe's poolside ambiance, delicious food, and elegant interiors. Experience the best dining atmosphere in Rajkot."
    },
    events: {
        title: "Events & Private Dining | White Valley Cafe Rajkot - Banquet Hall",
        description: "Host your special events at White Valley Cafe. Private dining, birthday parties, anniversaries, corporate events, and banquet hall available in Rajkot."
    },
    about: {
        title: "About Us | White Valley Cafe - Best Multicuisine Restaurant in Rajkot",
        description: "Learn about White Valley Cafe, Rajkot's premier poolside multi-cuisine vegetarian restaurant. Discover our story, experience, and commitment to exceptional dining."
    },
    contact: {
        title: "Contact Us | White Valley Cafe Rajkot - Location & Reservations",
        description: "Contact White Valley Cafe at 081417 07107. Located at Dharamshi Korat Rd, Mota Mava, Rajkot 360005. Open daily 10 AM - 1 AM. Reserve your table today!"
    },
    valentine: {
        title: "Valentine's Day Special | White Valley Cafe - Romantic Poolside Dining Rajkot",
        description: "Celebrate Valentine's Day at White Valley Cafe with our special poolside romance package at ₹1999. Includes mocktails, sizzler, brownie & table decoration."
    }
};

// Custom hook to set page-specific SEO
export const useSEO = (page) => {
    useEffect(() => {
        const config = seoConfig[page] || seoConfig.home;

        // Update title
        document.title = config.title;

        // Update meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', config.description);
        }

        // Update OG title
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) {
            ogTitle.setAttribute('content', config.title);
        }

        // Update OG description
        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription) {
            ogDescription.setAttribute('content', config.description);
        }

        // Update Twitter title
        const twitterTitle = document.querySelector('meta[name="twitter:title"]');
        if (twitterTitle) {
            twitterTitle.setAttribute('content', config.title);
        }

        // Update Twitter description
        const twitterDescription = document.querySelector('meta[name="twitter:description"]');
        if (twitterDescription) {
            twitterDescription.setAttribute('content', config.description);
        }
    }, [page]);
};

export default seoConfig;
